import { Row, Col } from 'react-bootstrap';
import PercentageField from '../../../fields/PercentageField';
import IncomeInformationInputs from '../../../common/IncomeInformationInputs';
import CalculatedIncomeResults from '../../../common/CalculatedIncomeResults';
import ReferralSourceField from '../../../fields/ReferralSourceField';
import CaresBenefitDiff from '../CaresBenefitDiff';

const CaresDiscountOnlySection = ({
  form,
  currentEnergyDiscount,
  setFormField,
  hasExistingCaresData,
  isSubmitting,
}) => {

  return (
    <>
      <hr/>
      {/* Income Information */}
      <Row>
        <Col>
          <h4>Income Information</h4>
          <IncomeInformationInputs
            householdSize={form?.householdSize}
            onHouseholdSizeChange={value => setFormField('householdSize', value)}
            income={form?.income}
            onIncomeChange={value => setFormField('income', value)}
            isSubmitting={isSubmitting}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <CalculatedIncomeResults
            incomeMeasurementType={form?.incomeMeasurementType}
            incomeMeasurementPercentage={form?.incomeMeasurementPercentage}
            arrearage={form?.arrearage}
            isSubmitting={isSubmitting}
          />
        </Col>
      </Row>

      <hr/>
      {/* Benefit Amounts */}
      <Row>
        <Col><h4>Benefit Amount</h4>
          <Row>
            <Col md={6}>
              <PercentageField
                value={form?.energyDiscount}
                fieldName="Energy Discount"
                readonly
                disabled
                isSubmitting={isSubmitting}
                />
            </Col>
          </Row>
        </Col>
      </Row>

      <CaresBenefitDiff
        fundType={form?.fundType}
        newEnergyDiscount={form?.energyDiscount}
        currentEnergyDiscount={currentEnergyDiscount}
      />

      {!hasExistingCaresData && (
        <>
          <hr/>
          <ReferralSourceField 
            value={form?.referralSource}
            onChange={value => setFormField('referralSource', value)}
            isSubmitting={isSubmitting}
          />
        </>
      )}
    </>
  );
};

export default CaresDiscountOnlySection;